import { registerRootComponent } from "expo";
import App from "./App";

export default registerRootComponent(App);
